export default __webpack_public_path__ + "static/media/pouchnation-logo.21c4705c.svg";